import type { Dispatch, AnyAction } from 'redux';

import * as FindForJobAPI from 'ab-api/web/materialJobMarkupHistory/findForJob';
import * as UpsertAPI from 'ab-api/web/materialJobMarkupHistory/upsert';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function findForJob(jobId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindForJobAPI.W_MaterialJobMarkupHistory_FindForJob_VM>(FindForJobAPI.URL(jobId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function upsert(jobId: number, data: UpsertAPI.W_MaterialJobMarkupHistory_Upsert_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<UpsertAPI.W_MaterialJobMarkupHistory_Upsert_VM>(UpsertAPI.URL(jobId), data);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
